/* src/app/components/datepicker/datepicker.component.scss */
.date-picker {
  position: relative;
}
.date-picker .is-invalid {
  background-image: none;
}
::ng-deep .error .date-picker::after,
.date-picker:has(.is-invalid)::after {
  font-family: "upsicons", fantasy !important;
  content: "\e638" !important;
  color: var(--error-color);
  position: absolute;
  top: calc(50% - 0.7rem);
  right: 3rem;
  font-size: 16px;
}
.error input {
  border-top: 1px solid var(--error-color);
  border-bottom: 1px solid var(--error-color);
  border-left: 1px solid var(--error-color);
}
.error button {
  border: 1px solid var(--error-color);
}
.calendar.icon:before {
  font-family: upsicons, fantasy !important;
  content: "\e61e" !important;
  color: #00857D;
}
.calendar-btn {
  background-color: white;
  padding: 4.5px 8.5px;
}
.date-text {
  padding: 6px 12px;
  font-size: 14px;
  border-radius: 0;
}
.input-group {
  width: 100%;
}
:host ::ng-deep ngb-datepicker-navigation {
  background-color: #FFF !important;
}
:host ::ng-deep .ngb-dp-header {
  background-color: #FFF !important;
}
:host ::ng-deep .ngb-dp-content {
  margin-top: 1em;
}
:host ::ng-deep .ngb-dp-content .bg-primary {
  background-color: #FFD102 !important;
  border: 1px solid #757575 !important;
  color: #000 !important;
}
:host ::ng-deep .ngb-dp-navigation-select {
  flex: 1 1 100% !important;
  padding-left: 1em;
  padding-right: 1em;
  width: 100% !important;
}
@media screen and (max-width: 767px) {
  :host ::ng-deep .ngb-dp-navigation-select {
    flex-direction: column;
    margin-top: 3px;
  }
}
:host ::ng-deep .ngb-dp-navigation-select:before {
  position: absolute;
  font-family: upsicons, fantasy !important;
  content: "\e626" !important;
  color: #00857D;
  z-index: 20;
  pointer-events: none;
}
@media screen and (min-width: 767px) {
  :host ::ng-deep .ngb-dp-navigation-select:before {
    left: 255px;
    top: 8px;
  }
}
@media screen and (max-width: 767px) {
  :host ::ng-deep .ngb-dp-navigation-select:before {
    left: 15rem;
    top: 1rem;
  }
}
:host ::ng-deep .ngb-dp-navigation-select:after {
  position: absolute;
  font-family: upsicons, fantasy !important;
  content: "\e626" !important;
  color: #00857D;
  z-index: 20;
  pointer-events: none;
}
@media screen and (min-width: 767px) {
  :host ::ng-deep .ngb-dp-navigation-select:after {
    right: 58px;
    top: 8px;
  }
}
@media screen and (max-width: 767px) {
  :host ::ng-deep .ngb-dp-navigation-select:after {
    left: 15rem;
    top: 3rem;
  }
}
:host ::ng-deep .ngb-dp-navigation-select .form-select {
  border: 1px solid #979797;
  margin-left: 0.6em;
  font-weight: bold;
  background: #FFF !important;
  outline: none !important;
}
@media screen and (max-width: 767px) {
  :host ::ng-deep .ngb-dp-navigation-select .form-select {
    margin-top: 3px;
  }
}
:host ::ng-deep .ngb-dp-navigation-chevron {
  color: #000;
  font-size: 0.8rem;
}
:host ::ng-deep .ngb-dp-content .ngb-dp-day {
  text-decoration: underline;
  margin: 1px;
  text-align: center !important;
  outline: none !important;
  line-height: 3rem;
}
@media screen and (min-width: 767px) {
  :host ::ng-deep .ngb-dp-content .ngb-dp-day {
    width: 78px;
    height: 48px;
  }
}
@media screen and (max-width: 767px) {
  :host ::ng-deep .ngb-dp-content .ngb-dp-day {
    width: 2.62rem;
    height: 3rem;
  }
}
.ngb-dp-day:hover,
.ngb-dp-day.focused {
  background-color: #E2E6EA;
}
:host ::ng-deep .ngb-dp-content .ngb-dp-day .outside {
  background-color: #F7F6F5;
  color: #000 !important;
  opacity: 1;
}
:host ::ng-deep .ngb-dp-content .ngb-dp-weekday {
  font-weight: bold;
  color: #000;
  font-style: normal;
  margin: 1px;
  background-color: #D6D6D6;
  height: 1.4rem !important;
  line-height: 1.4rem !important;
}
@media screen and (min-width: 767px) {
  :host ::ng-deep .ngb-dp-content .ngb-dp-weekday {
    width: 78px;
  }
}
@media screen and (max-width: 767px) {
  :host ::ng-deep .ngb-dp-content .ngb-dp-weekday {
    width: 2.62rem;
  }
}
:host ::ng-deep ngb-datepicker .footer [class*=-btn] {
  border: 0 !important;
  padding: 0.5em;
  padding-left: 1.5em;
  padding-right: 1.5em;
  background-color: #00857D;
  color: #FFF;
}
:host ::ng-deep ngb-datepicker .footer .today-btn {
  background-color: #FFD102;
  color: #000;
}
::ng-deep .datepicker-container input[type=text] {
  width: 100%;
}
:host ::ng-deep .right-datepicker {
  margin-left: 42px;
}
.comments-indicator {
  height: 28px;
  width: 28px;
  line-height: 28px;
  background-color: #F88C00;
  border-radius: 50%;
  text-align: center;
  position: absolute;
}
.comments-indicator.icon::after {
  font-family: upsicons, fantasy !important;
  content: "\e62f" !important;
  color: #000000;
  font-size: 20px !important;
}
.dp-meatball {
  text-decoration: none !important;
  position: relative;
  text-align: center;
  z-index: 100;
}
@media screen and (min-width: 767px) {
  .dp-meatball {
    bottom: 3.35rem;
    left: 1rem;
  }
}
@media screen and (max-width: 767px) {
  .dp-meatball {
    bottom: 3.1rem;
  }
}
/*# sourceMappingURL=datepicker.component.css.map */
